export default __webpack_public_path__ + "static/media/form.54b55ade.svg";